@for (element of formBuilder.layout$ | async; track element.uid) {
  <pr-preview-form-issue-element [element]="element" />
}
